import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {shareReplay, switchMap} from 'rxjs/operators';
import {v4 as uuidv4} from 'uuid';
import {FrontLocalStorageService} from '../storage/localStorage.service';


@Injectable({
    providedIn: 'root'
})
export class IziviaDeviceService {
    public readonly deviceId$: Observable<string>;

    constructor(private readonly storageService: FrontLocalStorageService) {
        const DEVICE_ID: string = 'DEVICE_ID';

        this.deviceId$ = this.storageService.get<string>(DEVICE_ID)
            .pipe(
                switchMap(deviceId => {
                    if (!deviceId) {
                        deviceId = this.fetchDeviceId();
                        return this.storageService.set<string>(DEVICE_ID, deviceId);
                    } else {
                        return of(deviceId);
                    }
                }),
                shareReplay(1)
            );
    }

    private fetchDeviceId(): string {
        return uuidv4();
    }
}
